<template>
    <section>
        <b-loading :active.sync="isLoading"></b-loading>
        <titlebar :title-stack="titleStack"></titlebar>
        <ValidationObserver ref="observer">
            <div class="box">
                 
                <b-tabs type="is-boxed"  v-model="tabsPrincipal" >
                           
                    <b-tab-item value="astecs"   :label="$t('SISTEMA.ASTECS')" icon="cogs">
                        <template #header>                                                        
                            <b-icon icon="cogs"></b-icon>  
                            <span> Astecs </span>                                                     
                        </template>            
                        <div class="columns">                    
                        
                        <div class="column is-9">
                            <div class="columns">
    
                                <div class="column is-3">
                                    <b-field :label="$t('ASTECS.EMITIDA')">
                                        <b-input v-model="guia.dataHoraCadastroStr" readonly  disabled></b-input>
                                    </b-field>
                                </div>
                                <div class="column is-3" >
                                    <b-field :label="$t('ASTECS.TIPOCONTATO')">                                   
                                        <b-select expanded v-model="guia.tipoContato" disabled>                                            
                                            <template v-for="(item, index) in tipoContatos">
                                                <option v-bind:key="index" :value="item.valor">
                                                    {{item.descricao}}
                                                </option>
                                            </template>
                                        </b-select>                                        
                                    </b-field>                             
                                </div>   

                            <div class="column is-3" >
                            </div> 
                            <div class="column is-3" >
    
                                        
                            </div>                                                                                    
                                
                            </div>                        
                            <div class="columns">
                                <searchIdName class="column is-9" :id.sync="guia.clienteCodigoExterno"  :codigoExterno="true"
                                :trazDesativado="true" :label="$t('SISTEMA.CLIENTE')" table="Cliente" :camposAdicionais="'&unidadeId='+unidadeId" :leitura="true">
                                <slot>
                                            <b-button icon-left="square-edit-outline"
                                                    tag="router-link"
                                                    :to="{ name: 'cliente', params: { id: guia.clienteCodigoExterno, codigoExterno: true }}"
                                                    :title="$t('GUIAATENDIMENTO.INFOCLIENTE')"></b-button>
                                            <b-button icon-left="refresh"  @click="confirmarAtualizarClienteEfinance()"                                                      
                                                    :title="$t('GUIAATENDIMENTO.ATUALIZARCLIENTE')"></b-button>                                                        
                                </slot>                                    
                                </searchIdName>                                                           

                            </div>  
                            <div class="columns">
                                <searchIdName class="column is-9" :id.sync="guia.funcionarioInstaladorId" :trazDesativado="false" 
                                :label="$t('ASTECS.RESPONSAVELTECNICO')" table="FuncionarioInstalador"
                                :camposAdicionais="'&unidadeId='+unidadeId" >
                                    <slot>
                                        <b-button  icon-left="check-bold"  @click="confirmarReponsavelTecnico()"                                                      
                                                :title="$t('GUIAATENDIMENTO.RESPONSAVELTECNICO')"></b-button>                                                        
                                    </slot>                                 
                                </searchIdName>
                                 
                            </div>  

                            <div class="columns">
                                <b-switch size="is-small"  v-model="verEndereco"    > Ver Endereço?</b-switch>                                                                                    
                            </div>
                            

                            <div v-if="this.verEndereco" class="columns">   
                                <div class="column is-6">
                                    <b-field :label="$t('MODALINSERIRNOVAASTEC.ENDERECO')">                                  
                                        <b-input    :disabled="true" type="text" v-model="this.cliente.endereco"> </b-input>
                                    </b-field>                        
                                </div>
                                <div class="column is-6">
                                    <b-field :label="$t('MODALINSERIRNOVAASTEC.COMPLEMENTO')">                                  
                                        <b-input     :disabled="true" type="text" v-model="this.cliente.complemento"> </b-input>
                                    </b-field>                        

                                </div>                    
                            </div>

                            <div v-if="this.verEndereco" class="columns">   
                                <div class="column is-3">
                                    <b-field :label="$t('MODALINSERIRNOVAASTEC.BAIRRO')">                                  
                                        <b-input  :disabled="true"     type="text" v-model="this.cliente.bairro"> </b-input>
                                    </b-field>                        

                                </div>
                                <div class="column is-3">
                                    <b-field :label="$t('MODALINSERIRNOVAASTEC.CIDADE')">                                  
                                        <b-input  :disabled="true"      type="text" v-model="this.cliente.cidade"> </b-input>
                                    </b-field>                        

                                </div>
                                <div class="column is-3">
                                    <b-field :label="$t('MODALINSERIRNOVAASTEC.UF')">                                  
                                        <b-input   :disabled="true"     type="text" v-model="this.cliente.uf"> </b-input>
                                    </b-field>                        

                                </div>
                                <div class="column is-3">
                                    <b-field :label="$t('MODALINSERIRNOVAASTEC.CEP')">                                  
                                        <b-input  :disabled="true"      type="text" v-model="this.cliente.cep"> </b-input>
                                    </b-field>                        

                                </div>                                         
                            </div>    
                
                            
                            <div v-if="this.verEndereco" class="columns">   
                                <div class="column is-6">
                                    <b-field :label="$t('MODALINSERIRNOVAASTEC.REFERENCIA')">                                  
                                        <b-input     :disabled="true" type="text" v-model="this.cliente.referencia"> </b-input>
                                    </b-field>                        
                                </div>
                                <div class="column is-3">
                                    <b-field :label="$t('MODALINSERIRNOVAASTEC.TELEFONE')">                                  
                                        <b-input      :disabled="true"  type="text" v-model="this.cliente.telefone"> </b-input>
                                    </b-field>                        

                                </div>                 
                                <div class="column is-3">
                                    <b-field :label="$t('MODALINSERIRNOVAASTEC.EMAIL')">                                  
                                        <b-input     :disabled="true"  type="text" v-model="this.cliente.email"> </b-input>
                                    </b-field>                        

                                </div>                                        
                            </div>  
                            
                            <div class="columns">    
                                <div class="column is-12">
          
                                    <div  v-if="guia && guia.dataHoraConclusaoVisita !=null ">
                                        <div class="columns">
                                            <div class="column is-6">      
                                                <b-button v-if="guia.status!=6" type="is-success" icon-left="cog"  @click="incluirOcorrencia()"> 
                                                    {{$t('ASTECS.SOLICITACAO')}} </b-button>                                                                                        
                                            </div>
                                            <div class="column is-6">      

                                            </div>

                                        </div>   
                                        <div  class="b-table">
                                            <div class="table-wrapper has-mobile-cards">                                     
                                                <table class="table is-fullwidth">
                                                    <thead>
                                                        <tr>                                                    
                                                            <th class="is-size-7">Tipo</th>
                                                            <th class="is-size-7">Descrição</th>    
                                                            <th class="is-size-7">Etapa</th>                                                                                                                                                                                                                     
                                                            <th ></th>
                                                        </tr>                                                
                                                    </thead>
                                                    <tbody> 
                                                        <tr  :class="item.atraso ? 'bg-atraso' : '' " v-for="(item, index) in listaOcorrencias" :key="index">                                                    
                                                            <td class="is-size-7" >                                                                      
                                                                {{item.tipoNome}}                                                                                                                                                                                                                                                               
                                                            </td>
                                                            <td class="is-size-7"><span v-html="tratamentoQuebraLinha(item.observacao)"></span> </td> 
                                                            <td class="is-size-7">{{ item.etapaAtual }} </td>                                                                                                       
                                                            <td>                     
                                                                <div style="display: flex;">

                                                                    <span v-if="item.dataHoraCancelado !=null">
                                                                        <b-icon icon="close-circle"
                                                                                        size="is-small"                                    
                                                                                        :title="$t('ASTECS.SOLICITACAOEXCLUIDA')"
                                                                                        type="is-danger"></b-icon> 
                                                                    </span>                                                        
                                                                    <span v-else-if="item.dataHoraConcluido !=null">
                                                                        <b-icon icon="check"
                                                                                        size="is-small"                                    
                                                                                        :title="$t('ASTECS.SOLICITACAOCONCLUIDA')"
                                                                                        type="is-success"></b-icon> 
                                                                    </span>
                                                                    <span v-else>
                                                                        <b-icon icon="information"
                                                                                        size="is-small"                                    
                                                                                        :title="$t('ASTECS.SOLICITACAONAOCONCLUIDA')"
                                                                                        type="is-warning"></b-icon>                                                             
                                                                    </span>                                                                                                                          
                                                                    <b-button v-if="item.dataHoraCancelado ==null" :title="$t('SISTEMA.EDITAR')" class="ml-1  is-small is-primary" @click="incluirOcorrencia(item.id)" icon-left="pencil"></b-button>   
                                                                    <b-button v-if=" item.dataHoraConcluido ==null && item.dataHoraCancelado ==null" :title="$t('SISTEMA.REMOVER')" class="ml-1 is-small is-danger" @click="excluirOcorrencia(item.id)" icon-left="delete"></b-button>                                                       

                                                                </div>                                   

                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>                      
                                    </div>           
                                                                                                                                                                                                                        
                                </div>
                                
                        
                            </div>                              
                
                        </div>
                        <div class="column is-3">                        
            
                            <div class="columns"  >
                                <div class="column is-12">
                                    <b-notification v-if="guia.dataHoraCancelado !=null" type="is-danger" has-icon icon-size="is-medium" :closable="false" role="alert" >
                                        {{$t('ASTECS.GUIACANCELADA').toUpperCase()}}
                                    </b-notification> 
                               
                                    <div v-if="guia.id != 0" class="form-control-static">
                                        
                                        <div class="buttons has-addons is-centered m-0 "> 
                                            <b-button v-if="guia.status!=1 && guia.dataHoraCancelado ==null "  
                                            @click="confirmarCancelamento(false)" 
                                            :title="$t('ASTECS.CANCELARASTECS')"                                                                                        
                                            icon-left="close-circle" type="has-text-danger"></b-button>

                                            <b-button v-if="guia.status!=1 && guia.dataHoraCancelado ==null "  
                                            @click="confirmarTrocaResponsavelTecnico()" 
                                            :title="$t('ASTECS.TROCARRESPONSAVELTECNICO')"                                                                                        
                                            icon-left="account-switch" ></b-button>     

                                            <b-button v-if="guia.dataHoraCancelado ==null "  @click="confirmarInclusaoObservacao()" 
                                            :title="$t('ASTECS.INCLUIROBSERVACAO')"                                                                                        
                                            icon-left="comment"></b-button>                                                 
                                                                                           
                                        </div>   
                                        <b-notification v-if="guia && !paraAnaliseVisita && guia.dataHoraConclusaoVisita == null  && agendamentos.length>0" type="is-info" has-icon icon-size="is-medium" :closable="false" role="alert" >
                                                    {{$t('ASTECS.AGENDAMENTOPARAVISITAASTEC').toUpperCase()}}                                  
                                        </b-notification>                                            

                                        <article v-if="guia  && paraAnaliseVisita && guia.dataHoraConclusaoVisita ==null  "  class="panel">
                                                    <b-field>
                                                        <b-switch  v-model="guia.devolverAbertura" @input="confirmarDevolucaoAbertura()" type="is-success">
                                                            {{$t('ASTECS.DEVOLVERABERTURA')}}
                                                        </b-switch>                                            
                                                    </b-field>                                                
                                                    <b-field>
                                                        <b-switch  v-model="guia.concluirVisitaAstec" @input="confirmarConcluirVisitaAstec()" type="is-success">
                                                            {{$t('ASTECS.CONCLUIRVISITAASTEC')}}
                                                        </b-switch>                                            
                                                    </b-field>       
                                                    <b-field>
                                                        <b-switch  v-model="guia.preencherFichaVisita" @input="abrirFichaVisita()" type="is-success">
                                                            {{$t('ASTECS.PREENCHERFICHAVISITA')}}
                                                        </b-switch>                                            
                                                    </b-field>                                                           
                                                                                                                                                                     
                                        </article>
                                        <article v-if="guia && guia.dataHoraConclusaoVisita !=null  && guia.dataHoraAnaliseVisita ==null "  class="panel">
                                                    <b-field  >
                                                        <b-switch v-model="guia.analiseVisitaAstec" @input="confirmarAnaliseVisitaAstec()"  type="is-success">
                                                            {{$t('ASTECS.ANALISEVISITAASTEC')}}
                                                        </b-switch>                                           
                                                    </b-field>  
                                        </article>                                           
                                        
                                        <article v-if="guia && guia.dataHoraAnaliseVisita !=null"  class="panel">
                                                    <b-field  >
                                                        <b-switch v-model="guia.terminarAstec" @input="confirmarTerminarAstec()"  type="is-success">
                                                            {{$t('ASTECS.FECHARASTEC')}}
                                                        </b-switch>                                           
                                                    </b-field>  
                                        </article>                                                  
                                                                                                                                
                                        <article v-if="guia.funcionarioInstaladorId > 0"   class="panel">
                                                <div class="panel-heading has-text-centered">
                                                    {{$t('ATENDIMENTO.ULTIMOSAGENDAMENTOS')}}
                                                </div>   
                                                                                                                       
                                                <div v-for="(agendamento, index) in agendamentos.slice(0,5)" v-bind:key="index">
                                                    <a v-if="(agendamento.agendamentoAutomatico==false)" class="panel-block">
                                                        <span class="panel-icon block">                                            
                                                            <b-icon :style="tipoAgendamentoStyle(agendamento)"  size="is-small" icon="square-rounded"></b-icon>                                            
                                                        </span>                                        
                                                        <p> {{agendamento.tipoAgendamentoNome}} - {{ agendamento.dataHora }}</p>
                                                    </a>
                                                </div>   
                                                <div>
                                                    <a  @click="verTodosAgendamentos()" class="panel-block">
                                                            <span class="panel-icon block">                                            
                                                                <b-icon   size="is-small" icon="view-list"></b-icon>                                            
                                                            </span>                                        
                                                            <p> Ver todos</p>
                                                    </a> 
                                                </div>                                                                                                                                                                           
                                                <div class="panel-block">                                    
                                                    <b-button expanded class="button is-info" @click="abrirCalendario()" > {{$t('ATENDIMENTO.ABRIRCALENDARIO')}} </b-button>                                            
                                                </div>
                                        </article>                                          
                                        

                                                                                                
                                    </div>
                                </div> 
                                                                                                        
                            </div>

                
                        </div>
                            
                    </div>                                    
                                  
                    </b-tab-item>
                </b-tabs>

                <div class="columns ">
                    <div class="column is-12">      
                        <b-tabs v-model="tabs" multiline>
                            <b-tab-item value="observacoes" :label="$t('SISTEMA.OBSERVACAO')" icon="comment">
                                <div class="columns">
                                    <div class="column is-10">      
                                        <textarea class="textarea" v-model="guia.observacoes" rows="1"></textarea>
                                    </div>
                                                                                                                      
                                </div>

                                <article v-if="guia.id > 0" class="panel mb-0">
                                    <div class="panel-heading ">
                                        {{$t('ATENDIMENTO.ULTIMASINFORMACOES')}}
                                        <span class="is-pulled-right" >
                                            <b-select size="is-small" class="ml-5" v-model="filtroObservacoes" @input="loadHistoricoAlteracoes()">
                                                    <option value="Todos">Todos</option>
                                                    <option value="Usuario">Usuário</option>
                                                    <option value="Sistema">Sistema</option>
                                                </b-select>                                             
                                        </span>
                                    </div>    
                                    <div  class="b-table">
                                        <div class="table-wrapper has-mobile-cards">                                                                                             
                                            <table v-if="historicoAlteracoes !=null" class="table is-fullwidth">
                                                <tr v-for="(item, index) in historicoAlteracoes.slice(0,3)" :key="index">
                                                    <td >
                                                        <h4>
                                                            {{ item.observacao }}                                                                                      
                                                            <span v-if="item.chaveComplemento !=null"> 
                                                                <router-link :to="{ name: 'guia', params: { id:item.chaveComplemento, guiaList:true}}" class="button is-small is-primary" title="Abrir Atendimento">
                                                                    <b-icon icon="pencil" size="is-small"></b-icon>
                                                            </router-link>  
                                                            </span>                                  
                                                        </h4>
                                                    </td>
                                                    <td >
                                                        <span><b>{{ item.usuarioNome }}</b> ({{ item.usuarioId }})</span>
                                                    </td>
                                                    <td >
                                                        <span>{{ item.dataHora | moment('DD/MM/YYYY HH:mm') }}</span>
                                                    </td>
                                                </tr>
                                            </table>
                                        </div>      
                                    </div>                                                                                  
                                </article>
                                <b-collapse class="panel m-0" animation="slide" :open="false" >
                                    <template #trigger="props">
                                        <div
                                            class="card-header" role="button" :aria-expanded="props.open">
                                            <p class="card-header-title">
                                                {{$t('ATENDIMENTO.TODASINFORMACOES')}}
                                               
                                            </p>
                                            <a class="card-header-icon">
                                                <b-icon :icon="props.open ? 'menu-down' : 'menu-up'"> </b-icon>
                                            </a>
                                        </div>
                                    </template>
                                    

                                    <div  class="b-table">
                                        <div class="table-wrapper has-mobile-cards"> 
                                            <table v-if="historicoAlteracoes !=null"  class="table is-fullwidth">
                                                <tr v-for="(item, index) in historicoAlteracoes" :key="index">
                                                    <td >
                                                        <h4>
                                                           
                                                            {{ item.observacao }}  
                                                   
                                                            <span v-if="item.chaveComplemento !=null"> 
                                                                <router-link :to="{ name: 'guia', params: { id:item.chaveComplemento, guiaList:true}}" class="button is-small is-primary" title="Abrir Atendimento">
                                                                    <b-icon icon="pencil" size="is-small"></b-icon>
                                                            </router-link>  
                                                            </span>                                  
                                                        </h4>
                                                    </td>
                                                    <td >
                                                        <span><b>{{ item.usuarioNome }}</b> ({{ item.usuarioId }})</span>
                                                    </td>
                                                    <td >
                                                        <span>{{ item.dataHora | moment('DD/MM/YYYY HH:mm') }}</span>
                                                    </td>
                                                </tr>
                                            </table>  
                                        </div>
                                    </div>                                      
                                </b-collapse>

                                
                            </b-tab-item>

                            <b-tab-item v-if="guia.id != 0" value="anexos" :label="$t('GUIAATENDIMENTO.ANEXOS')" icon="paperclip">
                                <div class="columns">
                                    <div class="column is-4" >
                                        <b-field  v-if="visualizarAnexos()">
                                            <b-upload 
                                                    @input="confirmarAnexo"
                                                    v-model="fileList"                                                     
                                                    accept=".pdf,.jpg,.jpeg,.png,.mp4,.mov,.wmv,.PNG,.PDF,.JPG,.JPEG,.MP4,.MOV,.WMV,.DOCX,.docx"                                                    
                                                    drag-drop>
                                                <section class="section">
                                                    <div class="content has-text-centered">
                                                        <p>
                                                            <b-icon icon="upload"
                                                                    size="is-medium">
                                                            </b-icon>
                                                        </p>
                                                        <p>{{$t('ANEXOS.ARRASTEARQUIVOS')}}</p>
                                                        <p>({{$t('ANEXOS.APENASPDF')}})</p>
                                                    </div>
                                                </section>
                                            </b-upload>
                                        </b-field>
                                        <a v-if="visualizarAnexos()"  class="has-text-info" @click="adicionarUrlExterna()" :title="$t('GUIAATENDIMENTO.URLEXTERNA')">
                                            <b-icon  icon="link" size="is-small"></b-icon>
                                        </a>                                         
                                    </div>
                                    <div class="column is-8">
                                        <div  class="b-table">
                                            <div class="table-wrapper has-mobile-cards">    
                                                <table v-if="anexos!=null && anexos.length>0" class="table is-striped">
                                                    <thead>
                                                        <tr>
                                                            <th>Tipo</th>                        
                                                            <th>Nome</th>
                                                            <th>Data</th>
                                                            <th>Ação</th>
                                                        </tr>                                                
                                                    </thead>
                                                    <tbody>
                                                        
                                                        <tr :class="anexo.documentoDigital ? 'has-background-info-light' : '' " v-for="(anexo, index) in anexos" :key="index">
                                                            <td> {{retornaTipoAnexo(anexo)}} </td>
                                                            <td >                                        
                                                                <p>
                                                                    <a v-if=" anexo.formato==0" @click="visualizarAnexo(anexo.id, anexo.fileName)" class="is-size-7 text-nowrap"><b>{{ anexo.fileName }}</b></a>
                                                                    <a v-else-if="anexo.formato==1" @click="visualizarUrlExternaAnexo(anexo.anexo)" class="is-size-7 text-nowrap"><b>{{ anexo.fileName }}</b></a>
                                                                </p>
                                                            </td>

                                                            <td>{{ anexo.dataHora ? $moment(anexo.dataHora).format("DD/MM/YYYY") : ''}}</td>
                                                            
                                                            <td v-if="anexo.id ">        
                                                                <div class="is-inline-flex">
                                                                    <b-button 
                                                                            icon-left="pencil"
                                                                            type="is-primary"
                                                                            size="is-small"
                                                                            :title="$t('SISTEMA.EDITAR')"
                                                                            @click="editarAnexo(anexo)"></b-button>
                                                                    
                                                                    <span >
                                                                        <b-button 
                                                                            class="ml-2"
                                                                            icon-left="delete"
                                                                            type="is-danger"
                                                                            size="is-small"
                                                                            :title="$t('ANEXOS.REMOVERANEXO')"
                                                                            @click="removerAnexo(anexo.id)"></b-button> 
                                                                                                                                                                           
                                                                    </span>
                                                                    

                                                                </div>                                   
                                                            </td>
                                                        </tr>

                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div> 
                            </b-tab-item>  
                                                   
                        </b-tabs> 
                    </div>
                </div>                               
            </div>
            <nav class="level">
                <div class="level-item">
                    <p class="buttons">
                        <b-button  type="is-success"
                                  :loading="salvandoDados"
                                   @click="salvarGuia"
                                  icon-left="check-circle">
                            {{$t('SISTEMA.SALVAR')}}
                        </b-button>
                        <b-button  type="is-danger"
                                  native-type="button"
                                  icon-left="close-circle"
                                  @click="botaoVoltarTela()">
                            {{$t('SISTEMA.VOLTAR')}}
                        </b-button>

 
                        
                    </p>
                </div>
            </nav>
        </ValidationObserver>

    </section>
</template>

<style scoped>

</style>

<script>
    import { mapGetters, mapState } from 'vuex'
    import titlebar from '@/components/titlebar.vue'
    import searchIdName from '@/components/searchIdName.vue'   
    import modalObservacaoAstec  from '@/components/astecs/modalObservacaoAstec'  
    import modalDevolucaoAbertura  from '@/components/astecs/modalDevolucaoAbertura.vue'     
    import modalCancelandoAstec from '@/components/astecs/modalCancelandoAstec'
    import modalTrocarResponsavelTecnicoAstec from '@/components/astecs/modalTrocarResponsavelTecnicoAstec.vue'
    import modalPreencherTipoAnexo from '@/components/atendimento/modalPreencherTipoAnexo'   
    import modalUrlExternaAnexoAstec  from '@/components/astecs/modalUrlExternaAnexoAstec'
    import modalEditarAnexoAstec from '@/components/astecs/modalEditarAnexoAstec'    
    import modalConcluirVisitaAstec from '@/components/astecs/modalConcluirVisitaAstec.vue'  
    import modalCadastroOcorrenciasAstec from '@/components/astecs/modalCadastroOcorrenciasAstec.vue'  
    import modalListarAgendamentosCliente from '@/components/atendimento/modalListarAgendamentosCliente.vue' 
    import moment from 'moment'



    export default {
        data() {
            return {                
                      
                guia: {
                    id: null,   
                    clienteCodigoExterno:null,                                                         
                    unidadeDeCadastroId: null, 
                    tipoContato:null,
                    funcionarioInstaladorId: null          
                },
                cliente:{
                    endereco: null,
                    complemento:null,
                    bairro:null,
                    cidade:null,
                    uf: null,
                    cep:null,
                    referencia:null,
                    telefone:null,
                    email:null,                    

                },
                verEndereco:false,
                salvandoDados: false,                
                tabs: 'observacoes', 
                tabsPrincipal: 'astecs',
                isLoading: false,  
                historicoAlteracoes: null,                              
                fileList:null,
                agendamentos:[], 
                listaOcorrencias:[],                               
                filtroObservacoes: 'Usuario',         
                anexos:[], 
                tipoContatos:[],                
                paraAnaliseVisita: this.$route.params.paraAnaliseVisita ?? false,   
                paraAgendamento: this.$route.params.paraAgendamento ?? false,   
                voltarTela: this.$route.params?.voltarTela ?? null, 

            }
        },
        components: {
            titlebar,            
            searchIdName                               
        },
        computed: {
     
            titleStack() {
                return [
                    this.$t('SISTEMA.ATENDIMENTO'),                    
                    this.guia.id >0 ? this.guia.id : this.$t('SISTEMA.NOVO')
                ]
            },
            ...mapState([
                'unidadeId',
                'config',                                             
                'usuario', 
            ]),
            ...mapGetters([
                'isInRole'
            ]),           
        },
        mounted() {                             
            this.loadGuia();
        },
        watch: {
            // call again the method if the route changes
            '$route': 'loadGuia'
        },
        methods: {    
            
            verTodosAgendamentos(){                
                this.$buefy.modal.open({
                    parent: this,
                    component: modalListarAgendamentosCliente,
                    props: {
                        agendamentos: this.agendamentos                                                                                 
                    },  
                                                                            
                    hasModalCard: true,
                    trapFocus: true,
                    fullScreen: true
                })                   
            },            
            confirmarReponsavelTecnico(){

                this.$buefy.dialog.confirm({
                        title: 'Atualização',
                        message: 'Deseja atualizar o responsável técnico?',
                        type: 'is-info',
                        hasIcon: true,
                        cancelText: 'Não',
                        confirmText: 'Sim',
                        onConfirm: () => {


                                try {
                                    this.isLoading=true;
                                    this.$http.get(`/api/astecs/ConfirmarResponsavelTecnicoGuia?id=${this.guia.id}&funcionarioInstaladorId=${this.guia.funcionarioInstaladorId}`)
                                    .then((res) => {
                                        this.$buefy.toast.open({
                                            duration: 5000,
                                            message: this.$t('SISTEMA.SALVOSUCESSO'),
                                            type: 'is-success'
                                        })
                                    }).finally(() => {                                
                                        this.isLoading = false;    
                                        this.loadGuia();                                                                                                                                                               
                                    });                             
                                    
                                } catch (e) {
                                    this.isLoading=false;                        
                                    console.error(e);
                                }                             

                        }   
                    });             


            },            
            confirmarTerminarAstec(){
                
               if(this.listaOcorrencias.filter(x => x.dataHoraConcluido==null &&  x.dataHoraCancelado==null ).length>0){
                    this.$buefy.dialog.alert({
                        title: this.$t('ASTECS.ASTECSOBRIGATORIO'),
                        message: this.$t('ASTECS.OBRIGATORIOCONCLUIRASTECS'),
                        type: 'is-warning',
                        hasIcon: true
                    });
                    
                    setTimeout(() => {this.guia.terminarAstec = false;},500);                    
                }else{
                    this.$buefy.dialog.confirm({
                    message: this.$t('ASTECS.MENSAGEMFINALIZARPOSASTEC'),
                    cancelText: 'Não',
                    confirmText: 'Sim',                        
                    onConfirm: () => {                        
                        this.guia.terminarAstec = true;
                    },
                    onCancel: () => {                        
                        this.guia.terminarAstec = false;
                    },
                })    
                }


                  
            },                
            alterarAgendamento(astec){                
                this.$buefy.dialog.prompt({
                    title: this.$t('GUIAATENDIMENTO.AGENDAMENTOMENSAGEM'),                    
                    inputAttrs: {
                        type: 'date',                        
                        placeholder: 'Agendamento',
                        value: astec.dataHoraAgendamento
                    }, 
                    confirmText: 'Confirmar',
                    cancelText: 'Cancelar',
                    trapFocus: true,
                    onConfirm: (res) => {
                        this.$http.get(`/api/astecs/DataHoraAgendamentoOcorrenciaAstec?prazo=${moment(res).format('YYYY-MM-DDTHH:mm:ss')}&id=${astec.id}`)
                        .then((r) => {
                            this.$buefy.toast.open({
                                duration: 5000,
                                message: this.$t("SISTEMA.SALVOSUCESSO"),
                                type: 'is-success'
                            });
                            astec.dataHoraAgendamento = moment(res).format('DD/MM/YYYY');
                        }, error => {
                            this.$buefy.toast.open({
                                duration: 5000,
                                message: "Não foi possível salvar a data",
                                type: 'is-danger'
                            });
                            astec.dataHoraAgendamento= null;
                        }                        
                        ).finally(() => {      
                            this.carregarAstecs();                                                                
                        }); 
                        
                    }
                });                
                return true;
            },              
            excluirOcorrencia(astecid){
                 this.$buefy.dialog.confirm({
                    message: this.$t('ASTECS.MENSAGEMCONFIRMAEXCLUSAOASTECS'),
                    cancelText: 'Não',
                    confirmText: 'Sim',                        
                    onConfirm: () => {                        
                        try {
                                
                            this.$http.get(`/api/astecs/CancelarAstecOcorrencia?id=${astecid}`)
                            .then((res) => {
                                this.$buefy.toast.open({
                                    duration: 5000,
                                    message: this.$t('SISTEMA.SALVOSUCESSO'),
                                    type: 'is-success'
                                })
                            }).finally(() => {                                
                                this.isLoading = false;    
                                this.loadGuia();                                                                                                    
                            });                             
                            
                        } catch (e) {
                            this.salvandoDados=false;                        
                            console.error(e);
                        }                        
                    },
                    onCancel: () => {                        
                        return true;
                    },
                })
            },            
            tratamentoQuebraLinha(texto){                
                return (texto) ? texto.replaceAll('\\n', '<br/>') : '';
            },    
            
            incluirOcorrencia(ocorrenciaId){
                this.$buefy.modal.open({
                    parent: this,
                    component: modalCadastroOcorrenciasAstec,
                    props: {
                        id: ocorrenciaId,
                        clienteCodigoExterno: this.guia.clienteCodigoExterno,
                        astecId: this.guia.id                       
                    },
                    events: {
                        carregarAstecs: this.carregarAstecs,
                        loadAnexos: this.loadAnexos,
                        loadHistoricoAlteracoes: this.loadHistoricoAlteracoes                       
                    },
                    hasModalCard: true,
                    trapFocus: true,
                    fullScreen:true
                })
            },                

            carregarAstecs(){
                this.isLoading=true;
                this.$http.get('/api/astecs/retornarOcorrenciasPorAstecId?id=' + this.guia.id)
                        .then(res => res.data)
                        .then(data => {

                            if (data != null && data.length>0 ) {
                                
                                this.listaOcorrencias = data?.map( (d) => {
                                        return {
                                            id: d.id,                                        
                                            clienteId: d.clienteId,                                        
                                            titulo: d.titulo,
                                            observacao: d.observacao,
                                            dataHoraCadastro: moment(d.dataHoraCadastro).format('DD/MM/YYYY HH:mm:ss'),                                                                                        
                                            eList: d.eList,
                                            faturado: d.faturado,
                                            dataHoraAprovacaoFabrica: (d.dataHoraAprovacaoFabrica) ? moment(d.dataHoraAprovacaoFabrica).format('DD/MM/YYYY HH:mm:ss') : null, 
                                            dataHoraAprovacaoFinanceiro: (d.dataHoraAprovacaoFinanceiro) ? moment(d.dataHoraAprovacaoFinanceiro).format('DD/MM/YYYY HH:mm:ss') : null, 
                                            dataHoraAprovacaoOrcamento: (d.dataHoraAprovacaoOrcamento) ? moment(d.dataHoraAprovacaoOrcamento).format('DD/MM/YYYY HH:mm:ss') : null, 
                                            dataHoraEntrega: (d.dataHoraEntrega) ? moment(d.dataHoraEntrega).format('DD/MM/YYYY HH:mm:ss') : null, 
                                            dataHoraEnvioFabrica: (d.dataHoraEnvioFabrica) ? moment(d.dataHoraEnvioFabrica).format('DD/MM/YYYY HH:mm:ss') : null, 
                                            dataHoraInstalacao: (d.dataHoraInstalacao) ? moment(d.dataHoraInstalacao).format('DD/MM/YYYY HH:mm:ss') : null, 
                                            dataHoraConcluido: (d.dataHoraConcluido) ? moment(d.dataHoraConcluido).format('DD/MM/YYYY HH:mm:ss') : null, 
                                            dataHoraCancelado: (d.dataHoraCancelado) ? moment(d.dataHoraCancelado).format('DD/MM/YYYY HH:mm:ss') : null,                                                                                  
                                            dataHoraAgendamento: (d.dataHoraAgendamento) ? moment(d.dataHoraAgendamento).format('DD/MM/YYYY') : null,                                                                                                                                  
                                            atraso: d.atraso,
                                            etapaAtual: d.etapaAtual,
                                            tipo: d.tipo,
                                            tipoNome: d.tipoNome                                             
                                        }
                                });                                                                                   
                            }                            

                        }).finally(() => {
                            this.isLoading = false;                             
                        });                
            },    
            
            abrirFichaVisita(){

                 this.$buefy.dialog.confirm({
                    message: this.$t('ASTECS.MENSAGEMFICHAVISITA'),
                    cancelText: 'Não',
                    confirmText: 'Sim',                        
                    onConfirm: () => { 

                            const campo = 'jotform_visita';
                            
                            const params = [];                                                                                                                                  
                            params.push(`campo=${campo}`);  
                            params.push(`unidadeId=${this.unidadeId}`);  

                            this.$http.get(`/api/search/UnidadeConfig?${params.join('&')}`)                        
                            .then(res => res.data)
                            .then(data => {                                                                     
                                window.open(data.valor + this.montarParametrosJotForm(), "_blank");                                                     
                            }).finally(() => {  
                                this.$router.push({ name: 'astecs'})                                                                
                            });



                        }
                    ,onCancel: () => {     
                       this.guia.preencherFichaVisita = false;                  
                        return true;
                    },                        
                    });                
            },
           
            montarParametrosJotForm(){
                return 'codigo='+this.guia.id+'&cliente='+ encodeURIComponent(this.guia.clienteCodigoExterno + " - " + this.guia.clienteNome)+'&usuario='+ encodeURIComponent(this.usuario.nome);
            },
            removerConfirmarConcluirVisitaAstec (){
                this.guia.concluirVisitaAstec = false;                
            },                   
            confirmarConcluirVisitaAstec(){
                this.$buefy.modal.open({
                    parent: this,
                    component: modalConcluirVisitaAstec,
                    props: {
                        id: this.guia.id,                        
                    },                    
                    events: {
                        loadData: this.loadGuia,
                        removerConfirmarConcluirVisitaAstec: this.removerConfirmarConcluirVisitaAstec
                    },                                                           
                    hasModalCard: true,
                    trapFocus: true,
                    fullScreen:true
                })
            },
            carregarAgendaGuia() {                
                this.$http.get('/api/agenda/agendamentosAstecs?id=' + this.guia.id)
                        .then(res => res.data)
                        .then(data => {
                            if (data != null && data.length>0 ) {
                              
                                
                                    this.agendamentos = data?.map( (d) => {
                                        return {
                                            id: d.id,                                        
                                            clienteId: d.clienteId,                                        
                                            tipoAgendamentoId: d.tipoAgendamentoId,
                                            tipoAgendamentoCor: d.tipoAgendamentoCor,
                                            tipoAgendamentoNome : d.tipoAgendamentoNome,
                                            agendamentoAutomatico: d.agendamentoAutomatico,
                                            dataHora: moment(d.dataHora).format('DD/MM/YYYY HH:mm:ss'),
                                            funcionarioResponsavelNome: d.funcionarioResponsavelNome,
                                            observacao: d.observacao
                                        }
                                    });  
                               

                            }
                        });
            },                    
            abrirCalendario(tipo =null,filtrarTiposAgenda = null, filtrarTodos = null,voltarTela = null){


                this.guia.tipoAgenda = 5;
                tipo=5;
                filtrarTiposAgenda = null;
                filtrarTodos = false;
                voltarTela =  this.voltarTela ?? 'astecs';                
                this.$router.push({ name: 'agenda', query:{ tipo: tipo, filtrarTodos: true}, params: { guia: this.guia, filtrarTiposAgenda:filtrarTiposAgenda,voltarTela:voltarTela}  });  
                             
            },            
            tipoAgendamentoStyle(evento) {
                return 'color: #' + evento.tipoAgendamentoCor + '!important'
            },             
            confirmarAberturaAstec(){
                 this.$buefy.dialog.confirm({
                    message: this.$t('ASTECS.MENSAGEMCONFIRMARASTECS'),
                    cancelText: 'Não',
                    confirmText: 'Sim',                        
                    onConfirm: () => {                        
                        this.salvandoDados=true;
                            const params = [];                                            
                            params.push(`id=${this.guia.id}`);                                                                          
                                                                            
                            try {
                                this.$http.get(`/api/astecs/ConfirmarAberturaAstec?${params.join('&')}`)
                                        .then(res => res.data)
                                        .then(data => {
                                            return true;
                                        }).finally(() => {      
                                            this.salvandoDados=false;                                                                                
                                            this.$router.back();                                                                    
                                        });                              
                                
                            } catch (e) {
                                this.salvandoDados=false;                        
                                console.error(e);
                            }

                            return true; 
                    },
                    onCancel: () => {                        
                        this.guia.confirmarAstec = false;
                    },
                })
            },  

            confirmarAnaliseVisitaAstec(){
                 this.$buefy.dialog.confirm({
                    message: this.$t('ASTECS.MENSAGEMCONFIRMARANALISEASTECS'),
                    cancelText: 'Não',
                    confirmText: 'Sim',                        
                    onConfirm: () => {                        
                        this.salvandoDados=true;
                            const params = [];                                            
                            params.push(`id=${this.guia.id}`);                                                                          
                                                                            
                            try {
                                this.$http.get(`/api/astecs/ConfirmarAnaliseVisitaAstec?${params.join('&')}`)
                                        .then(res => res.data)
                                        .then(data => {
                                            return true;
                                        }).finally(() => {      
                                            this.salvandoDados=false;                                                                                
                                            this.$router.back();                                                                    
                                        });                              
                                
                            } catch (e) {
                                this.salvandoDados=false;                        
                                console.error(e);
                            }

                            return true; 
                    },
                    onCancel: () => {                        
                        this.guia.analiseVisitaAstec = false;
                    },
                })
            },              
                      
            botaoVoltarTela(){
                this.voltarTela ? this.$router.push({ name: this.voltarTela})  :  this.$router.push({ name: 'astecs'});  
            },
            loadTipoContatos(){
                this.$http.get('/api/search/ListarTiposContato')
                .then(res => {
                    if (res.data != null) {
                        this.tipoContatos = res.data
                    }
                })   
            },        
            incluirObservacao(){                
                const guiaObservacao = {
                    guiaId: this.guia.id,
                    observacao : this.guia.observacoes
                }                
                this.isLoading = true;    
                this.$http.post('/api/astecs/guiaObservacoes', guiaObservacao)
                    .then(res => {

                        return true;

                    }).finally(() => {                                
                        this.isLoading = false;    
                        this.guia.observacoes = null;                        
                        this.loadHistoricoAlteracoes();
                    });                
            },

            salvarGuia(){
                this.salvandoDados = true;
                if (this.guia.unidadeDeCadastroId == null || this.guia.unidadeDeCadastroId==0  ) {                    
                    this.guia.unidadeDeCadastroId = this.unidadeId;
                }
                
                if(this.guia.dataHoraConcluido == null && this.guia.terminarAstec)
                    this.guia.dataHoraConcluido = new Date();                    
                  
                this.$http.post('/api/astecs/edit', this.guia)
                    .then(res => {
                        this.salvandoDados = false;                                        
                        this.$router.push({ name: this.voltarTela ?? 'astecs'});
                        
                    })
                    .catch(err => {
                        this.salvandoDados = false;
                        // restrições guia
                        if (err.status == 404) {
    
                                this.$buefy.toast.open({
                                    duration: 10000,
                                    message: err.body,
                                    type: 'is-danger',
                                    queue: false
                                });                                
                            
                        }
                        else {

                            const primeiralinha = err.body.substring(0, err.body.indexOf('\n'))
                            console.log('ERRO:' + err.body)

                            this.$buefy.toast.open({
                                duration: 10000,
                                message: err.body,
                                type: 'is-danger',
                                queue: false
                            })
                        }
                    }).finally(() => {                                
                        this.incluirObservacao();
                        this.carregarEndereco();
                    });
            },
            carregarEndereco(){

                if(this.guia.clienteId>0){
                    this.isLoading= true;


                    this.$http.get('/api/manutencao/cliente?id=' + this.guia.clienteId+"&codigoExterno=false&unidadeId="+this.unidadeId)
                        .then(res => {
                            this.cliente.endereco =  res.data.endereco;
                            this.cliente.complemento =  res.data.complemento;
                            this.cliente.bairro =  res.data.bairro;
                            this.cliente.referencia =  res.data.referencia;
                            this.cliente.cidade =  res.data.cidadeNome;
                            this.cliente.uf =  res.data.uf;
                            this.cliente.cep =  res.data.cep;
                            this.cliente.telefone =  res.data.fone;
                            this.cliente.email =  res.data.email;

                            
                        }).finally(() => {
                            this.isLoading= false;
                        });
                }else{
                    this.cliente.endereco =  null;
                    this.cliente.complemento =  null;
                    this.cliente.bairro =  null;
                    this.cliente.referencia =  null;
                    this.cliente.cidade =  null;
                    this.cliente.uf =  null;
                    this.cliente.cep =  null;
                    this.cliente.telefone =  null;
                    this.cliente.email =  null;
                }

            },            
            confirmarInclusaoObservacao() {
                this.$buefy.modal.open({
                    parent: this,
                    component: modalObservacaoAstec,
                    props: {
                        guia: this.guia                                              
                    },
                    events: {
                        loadData: this.loadGuia
                    },                    
                    hasModalCard: true,
                    trapFocus: true
                })
            },            
            confirmarDevolucaoAbertura(){
                this.$buefy.modal.open({
                    parent: this,
                    component: modalDevolucaoAbertura,
                    props: {
                        id: this.guia.id                                              
                    },
                    events: {
                        loadData: this.loadGuia
                    },                    
                    hasModalCard: true,
                    trapFocus: true
                })                
            },
            confirmarCancelamento(desistencia){
                
                this.$buefy.modal.open({
                    parent: this,
                    component: modalCancelandoAstec,
                    props: {
                        id: this.guia.id,
                        desistencia: desistencia
                    },
                    events: {
                        loadData: this.loadGuia
                    },
                    hasModalCard: true,
                    trapFocus: true
                })

            },  

            confirmarTrocaResponsavelTecnico(){
                
                this.$buefy.modal.open({
                    parent: this,
                    component: modalTrocarResponsavelTecnicoAstec,
                    props: {
                        guiaId: this.guia.id,
                        guiaFuncionarioInstaladorId : this.guia.funcionarioInstaladorId                        
                    },
                    events: {
                        loadData: this.loadGuia
                    },
                    hasModalCard: true,
                    trapFocus: true
                })

            },                 
            confirmarAtualizarClienteEfinance(){
                
                this.$buefy.dialog.confirm({
                    message: this.$t('GUIAATENDIMENTO.ATUALIZARCLIENTE'),
                    cancelText: 'Não',
                    confirmText: 'Sim',                        
                    onConfirm: () => {                        
                        try {
                            this.isLoading=true;
                            this.$http.get(`/api/integracao/AtualizarClienteElist?clienteId=${this.guia.clienteId}&unidadeId=${this.unidadeId}`)
                            .then((res) => {
                                this.$buefy.toast.open({
                                    duration: 5000,
                                    message: this.$t('SISTEMA.SALVOSUCESSO'),
                                    type: 'is-success'
                                })
                            }).finally(() => {                                
                                this.isLoading = false;                                                                                                                                                                 
                            });                             
                            
                        } catch (e) {
                            this.isLoading=false;                        
                            console.error(e);
                        }                        
                    },
                    onCancel: () => {                        
                        return true;
                    },
                })
            },   

            loadAnexos() {              
                this.fileList = null;                  
                this.anexos = null
                this.$http.get('/api/astecs/anexos?id=' + this.guia.id)
                    .then(res => {
                        if(res.data){
                            this.anexos = res.data  
                        }

                    })
            },             
            loadHistoricoAlteracoes() {
                this.$http.get('/api/astecs/GuiaObservacoes?id=' + this.guia.id)
                    .then(res => {
                        this.historicoAlteracoes = res.data
                        
                        if(this.filtroObservacoes != 'Todos')
                            this.historicoAlteracoes = this.historicoAlteracoes.filter(x=>x.tipo === this.filtroObservacoes); 
                                                    
                    })
            },             
            adicionarUrlExterna(){

                this.$buefy.modal.open({
                    parent: this,
                    component: modalUrlExternaAnexoAstec,
                    props: {
                        guia: this.guia                                              
                    },
                    events: {
                        loadData: this.loadGuia
                    },                    
                    hasModalCard: true,
                    trapFocus: true
                })                
       
            },             
            visualizarAnexos(){
            
                if(this.guia.id != 0)
                    return true;                
            },            
            editarAnexo(anexo)    {

                if(anexo.formato==0){
                    this.$buefy.modal.open({
                    parent: this,
                    component: modalEditarAnexoAstec,
                    props: {
                        anexo: anexo                        
                    },
                    events: {
                        loadData: this.loadGuia                        
                    },
                    hasModalCard: true,
                    trapFocus: true
                    })                        

                }else if (anexo.formato==1){

                    this.$buefy.modal.open({
                    parent: this,
                    component: modalUrlExternaAnexoAstec,
                    props: {
                        anexo: anexo,
                        editar:true                        
                    },
                    events: {
                        loadData: this.loadGuia                        
                    },
                    hasModalCard: true,
                    trapFocus: true
                })    

                }

            

            },

            incluirAnexo(tipoAnexoId) {

                const formData = new FormData()
                formData.append('id', this.guia.id);
                formData.append('type', 'guia');      
                formData.append('tipoAnexoSelecionadoId', tipoAnexoId);     
                formData.append('unidadeId', this.unidadeId);                                             
                formData.append('anexo', this.fileList, this.fileList.name);
                               
                this.isLoading = true;                    
                this.$http.post('/api/astecs/anexoGuia', formData, {
                    progress(e) {
                        return true;
                    }
                }).then(response => {                    
                    this.$buefy.toast.open({
                        duration: 5000,
                        message: response.data.sucesso,
                        type: 'is-success'
                    })
                    this.loadAnexos();
                    this.loadHistoricoAlteracoes();
                    this.isLoading = false;                    
                }, error => {
                    this.$buefy.toast.open({
                        duration: 5000,
                        message: error.message,
                        type: 'is-danger'
                    })
                });
       
            },            

            confirmarAnexo(){
                this.$buefy.modal.open({
                    parent: this,
                    component: modalPreencherTipoAnexo,
                    events: {
                        loadData: this.loadAnexos,
                        inlcuirAnexo: this.incluirAnexo                        
                    },
                    hasModalCard: true,
                    trapFocus: true
                })  
            },               

            removerAnexo(id) {
                const anexo = this.anexos.filter(x => x.id == id)[0]
                this.$buefy.dialog.confirm({
                    title: this.$t('ANEXOS.EXCLUIRANEXO'),
                    message: this.$t('ANEXOS.CONFIRMAEXCLUSAO') + anexo.fileName.replace(/^.*[\\/]/, '') + '</b> ?',
                    confirmText: this.$t('SISTEMA.CONFIRMAR'),                    
                    cancelText: this.$t('SISTEMA.CANCELAR'),                      
                    type: 'is-danger',
                    hasIcon: true,
                    onConfirm: () => {

                        const removerAnexo = {
                            tipo: "guia",
                            anexoId: id
                        }

                        this.isLoading = true;    
                        this.$http.post('/api/astecs/excluirAnexoGuia', removerAnexo)
                            .then((res) => {
                                if (res.body.erro) {
                                    this.$buefy.toast.open({
                                        duration: 5000,
                                        message: res.body.erro,
                                        type: 'is-danger'
                                    })
                                } else {
                                    this.loadAnexos()
                                }
                            }).finally(() => {                                
                                this.isLoading = false;  
                                this.loadHistoricoAlteracoes();  
                            });
                            
                    }
                })
            },               
            visualizarUrlExternaAnexo(url){
                window.open(url);
            },              
            visualizarAnexo(anexoId, fileName) {                
                window.open('/api/astecs/anexoPdf?id=' + this.guia.id + '&anexoId=' + anexoId + '&fileName=' + fileName);
            },            
            retornaTipoAnexo(anexo){
              
              if(parseInt(anexo.formato) == 0){
                  return anexo.tipoAnexoNome ?? 'NAO DEFINIDO';
              }else{
                  return 'LINK EXTERNO'
              }                 

            },                 
            loadGuia() {
                
                if(this.$route.params.atualizarUnidadeId){
                    this.$store.commit('SET_UNIDADE', this.$route.params.atualizarUnidadeId);
                }

                if (this.$route.params.id) {

                    this.isLoading = true;    
                    this.$http.get('/api/astecs/edit?id=' + this.$route.params.id)
                        .then(res => {                            
                            this.guia = res.data;
                            this.guia.dataHoraCadastroStr = this.$moment(res.data.dataHoraCadastro).format("DD/MM/YYYY HH:mm");      
                            this.guia.observacoes = null;                                                  

                        }).finally(() => {
                            this.loadTipoContatos();
                            this.loadAnexos();
                            this.loadHistoricoAlteracoes();
                            this.carregarEndereco();
                            this.carregarAgendaGuia();
                            this.carregarAstecs();
                            this.isLoading = false;    
                        });

                        
                }
                
            },   
                        


        }
    }
</script>